<template>
    <div class="landDetail">
        <leftnav class="fl" mkcode="A" :itemcode="yj_itemcode"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader></govheader>
            <div class="index_left_centerpage">
                <div class="whitebox py-4">
                    <div class="bgwidth" style="height: auto; padding-bottom: 40px">
                        <table cellspacing="0" cellpadding="4" border="0" class="detail_table  margin-x-auto" width="90%">
                            <tr>
                                <th class="thead font-bold" colspan="7">公告详细信息</th>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">公告标题:</td>
                                <td class="cols3" colspan="6">
                                    {{ baseinfo.projectName }}
                                </td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">项目名称::</td>
                                <td class="cols3" colspan="6">
                                    {{ baseinfo.projectName }}
                                </td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">投资地点:</td>
                                <td class="col2" colspan="3">
                                    {{ baseinfo.province }}{{ baseinfo.city
                                    }}{{ baseinfo.county }}
                                </td>
                                <td class="col3 font-bold">投资模式:</td>
                                <td class="col4" colspan="2">{{ baseinfo.ecNumber }}</td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">投资金额:</td>
                                <td class="col2" colspan="3">{{ baseinfo.approvalCompany }}</td>
                                <td class="col3 font-bold">投资时间:</td>
                                <td class="col4" colspan="2">{{ baseinfo.contractTime }}</td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">行业分类:</td>
                                <td class="cols3" colspan="3">{{ baseinfo.landOwner }}</td>
                                <td class="col1 font-bold">产业概念:</td>
                                <td class="cols3" colspan="2">{{ baseinfo.investment }}</td>
                                
                            </tr>
                            <tr>
                                <td class="col1 font-bold">公司简称:</td>
                                <td class="col2" colspan="3">{{ baseinfo.bigLandUse }}</td>
                                <td class="col1 font-bold">公司全称:</td>
                                <td class="col2" colspan="2">{{ baseinfo.useYears }}</td>
                            </tr>
                            <tr>
                                <td class="col3 font-bold">公司地点:</td>
                                <td class="col4" colspan="3">
                                    {{ baseinfo.smallIndustry }}
                                </td>
                                <td class="col1 font-bold">公司地址:</td>
                                <td class="col2" colspan="2">{{ baseinfo.landLevel }}</td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">公司法人:</td>
                                <td class="col2" colspan="3">{{ baseinfo.nSizeUnit }}</td>
                                <td class="col3 font-bold">联系电话:</td>
                                <td class="col4" colspan="2">{{ baseinfo.nPriceUnit }}</td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">项目描述:</td>
                                <td class="col2" colspan="6"><div class="showLine-10 text-left">{{ baseinfo.miaoshu }}</div></td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">公告内容</td>
                                <td class="col2" colspan="6"><div class="text-left" :class="{'showLine-10':!isShowText}">{{ baseinfo.content }}</div>
                                    <el-divider><span class="curp" @click="isShowText=!isShowText">{{ isShowText?'收起':'展开' }} <i class="el-icon-caret-bottom"></i></span></el-divider>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: "landDetail",
    computed: {
        ...mapState({
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapGetters(["isCollapse"]),
    },
    data() {
        return {
            userdata: {},
            yj_itemcode: "A",
            baseinfo: {
                province: "河北省",
                city: "唐山市",
                county: "",
                projectName: "海上风电法兰二期项目",
                projectLocation: "装备制造园区宏远路南侧",
                ecNumber: "123456",
                nSizeUnit: "58.98",
                source: "",
                bigLandUse: "工矿仓储用地",
                bigSupplyMode: "拍卖出让",
                smallSupplyMode: "",
                useYears: "50",
                smallIndustry: "金属制品业",
                landLevel: "十二级",
                nPriceUnit: "667",
                paymentList: [
                    { number: "1",
                    payTime: "2025/12/9",
                    landOwner: "唐山文丰重工有限公司",
                    memo: "",
                    },
                    { number: "2",
                    payTime: "2026/12/8",
                    landOwner: "唐山文丰重工有限公司",
                    memo: "",
                    },
                    { number: "3",
                    payTime: "2027/12/7",
                    landOwner: "唐山文丰重工有限公司",
                    memo: "",
                    },
                ],
                landOwner: "唐山文丰重工有限公司",
                volumeUpper: "",
                deliveryTime: "2026/12/8",
                startTime: "2027/12/7",
                endTime: "2029/12/6",
                realStartTime: "",
                realEndTime: "",
                approvalCompany: "曹妃甸区人民政府",
                contractTime: "2025/12/9",
                memo: "",
                volumeLower: "0.8",
                investment: "唐山文丰重工有限公司",
                miaoshu: "全球能源行业正处于快速发展和深度变革期，一方面，全球能源需求增长推动油气资源向超深井、非常规资源领域拓展，另一方面，能源行业正向智能化加速转型，进而带动了高性能油服连续管及管缆产品需求的不断提升，也加速了物联网、大数据、人工智能等技术与油采的深度融合。实施地为河北省唐山市。投资总额为 50,080.64 万元。",
                content:`本次发行证券方式：华通线缆拟向不特定对象发行总额不超过人民币80,000.00 万元（含本数）可转换公司债券，具体募集资金数额由公司股东会授权董事会或董事会授权人士在上述额度范围内确定。
  关联方是否参与本次向不特定对象发行：本次发行的可转换公司债券向公司原股东实行优先配售，原股东有权放弃配售权。向原股东优先配售的具体数量及比例提请股东会授权董事会或董事会授权人士在本次发行前根据市场情况与保荐机构（主承销商）协商确定，并在本次发行的发行公告中予以披露。
  一、本次发行符合向不特定对象发行证券的说明
  根据《中华人民共和国公司法》、《中华人民共和国证券法》、《上市公司证券发行注册管理办法》以及《可转换公司债券管理办法》等法律法规的规定，公司结合实际情况进行了逐项自查和论证，认为公司各项条件满足现行法律法规和规范性文件中关于向不特定对象发行可转换公司债券的有关规定，具备向不特定对象发行可转换公司债券的条件`,
                // 其他属性
            },
            isShowText:false,
        };
    },
    methods: {},
};
</script>
<style lang="scss">
.detail_table {
    border: 1px solid #f2f2f2;
    border-bottom: none;
    background: #fff;
    overflow: hidden;

    th,
    td {
        padding: 0 15px;
        text-align: center;
    }

    th {
        font-size: 16px;
        line-height: 54px;
        height: 54px;
        background: #f2f8fe;
        white-space: nowrap;
    }

    td {
        line-height: 24px;
        border-bottom: 1px solid #eee;
        min-width: 80px;
        font-size: 16px;
        text-align: center;
        padding-top: 8px;
        padding-bottom: 8px;
        max-width: 300px;
        border-right: 1px solid #eee;
        &.font-bold { 
            font-size: 16px;
        }
    }

    tr:hover {
        background: #fcfdff;
    }

    a {
        color: #2a51a4;
    }

    tr td:first-child {
        background: #fcfdff;
    }

    a:hover {
        text-decoration: underline;
        color: #f39800;
    }

    &.table {
        border-top: 1px solid #f2f2f2;
        border-left: 1px solid #f2f2f2;
    }
}

.clueManagement .whitebox {
    min-height: 95vh;
}
.showLine-10 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
</style>